import DefaultElementNodeType from '../DefaultElementNodeType';
import {BUSINESS_INTERFACE} from '../../metamodel/Concept';

export default class BusinessInterfaceNodeType extends DefaultElementNodeType {
	static get typeName() {
		return BUSINESS_INTERFACE;
	}
}
